import { FETCH_TOUR_STEPS } from "./index";

export const setTourSteps = (payload) => {
  return {
    type: FETCH_TOUR_STEPS,
    payload: payload,
  };
};
